import {useEffect,useMemo,useState} from "react";
import {api,type CertificationWorkflowKanbanScope,type CertificationWorkflowKanbanTemplate} from "./api";
import type {KanbanColumn} from "./kanban-board";

export function useCertificationWorkflowKanban(scope:CertificationWorkflowKanbanScope,onError:(message:string)=>void){
  const [template,setTemplate]=useState<CertificationWorkflowKanbanTemplate>();
  useEffect(()=>{
    api.certificationWorkflowKanbanTemplates()
      .then(items=>setTemplate(items.find(item=>item.scope===scope)))
      .catch(error=>onError(error.message));
  },[scope,onError]);
  return template;
}

export function workflowColumnForRow(template:CertificationWorkflowKanbanTemplate|undefined,row:{status:string;kanban_column_id?:string|null}){
  return template?.columns.find(column=>column.id===row.kanban_column_id)||template?.columns.find(column=>(column.statusKeys||[]).includes(row.status));
}

export function useWorkflowKanbanColumns(template:CertificationWorkflowKanbanTemplate|undefined){
  return useMemo<KanbanColumn[]>(()=>template?.columns.map(column=>({
    key:column.id,
    label:column.name,
    statuses:[column.id],
    color:column.color,
  }))||[],[template]);
}
